/**
 * @author       luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright    Copyright (c) 2025, Zumper
 */

import { Fees } from '@zcode/bizos'
import { FeeCadence, FeeType } from '@zcode/enums'

const sortFees = (feeA: Fees, feeB: Fees) => {
  // Sort by cadence first, from shortest to longest duration e.g. One-time → Monthly → Quarterly
  const cadenceDiff = feeA.cadence - feeB.cadence
  const sameCadence = cadenceDiff === 0
  // If same cadence, sort alphabetically
  if (sameCadence) {
    const feeAName = feeA.name.toLowerCase()
    const feeBName = feeB.name.toLowerCase()
    if (feeAName < feeBName) {
      return -1
    }
    if (feeAName > feeBName) {
      return 1
    }
    return 0
  }
  return cadenceDiff
}

export const getRequiredAndOptionalFees = (
  fees: readonly Fees[] | null | undefined,
  applicationFeeInCents: number | null | undefined
) => {
  const propertyFees = fees ?? []
  if (!applicationFeeInCents && !propertyFees.length) return null
  const required = []
  const optional = []
  for (const fee of propertyFees) {
    if (fee.isRequired) {
      required.push(fee)
    } else {
      optional.push(fee)
    }
  }
  if (!!applicationFeeInCents && !required.find((fee) => fee.type === FeeType.APPLICATION)) {
    required.push(
      new Fees({
        amount_in_cents: applicationFeeInCents,
        type: FeeType.APPLICATION,
        name: 'Application fee',
        cadence: FeeCadence.ONE_TIME,
        is_required: true,
      })
    )
  }
  required.sort(sortFees)
  optional.sort(sortFees)
  return { optional, required }
}
